import React, { useEffect, useRef, useState } from 'react';

// Wraps a horizontally scrollable table container (its first child) and shows a soft
// "scroll →" fade on the right edge while more columns are hidden off to the right.
const ScrollFade: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [more, setMore] = useState(false);

  useEffect(() => {
    const scroller = ref.current?.firstElementChild as HTMLElement | null;
    if (!scroller) return;
    const update = () => setMore(scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 1);
    update();
    scroller.addEventListener('scroll', update, { passive: true });
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
    ro?.observe(scroller);
    if (scroller.firstElementChild) ro?.observe(scroller.firstElementChild);
    return () => {
      scroller.removeEventListener('scroll', update);
      ro?.disconnect();
    };
  }, []);

  return (
    <div ref={ref} className={`scroll-fade ${className ?? ''}`} data-more={more ? 'true' : undefined}>
      {children}
    </div>
  );
};

export default ScrollFade;
